import React from 'react';
import { Gift } from 'lucide-react';
import './RewardSpinner.css';

/**
 * SpinnerButton - Attention-grabbing animated button for landing page
 * 
 * Features:
 * - Pulsing animation
 * - Glowing effect
 * - Eye-catching design
 */
const SpinnerButton = ({ onClick }) => {
  return (
    <button 
      className="spinner-cta-button"
      onClick={onClick}
      aria-label="Open spin to win wheel"
    >
      <span className="spinner-btn-glow"></span>
      <span className="spinner-btn-content">
        <Gift className="spinner-btn-icon" size={24} />
        <span className="spinner-btn-text">
          <span className="spinner-btn-title">🎁 Spin & Win!</span>
          <span className="spinner-btn-subtitle">Win up to 90% OFF</span>
        </span>
      </span>
    </button>
  );
};

export default SpinnerButton;
